import { buildMessage, IS_PHONE_NUMBER, isPhoneNumber, ValidateBy } from 'class-validator';
export function IsPhoneNumberWithLVS(region, validationOptions) {
    return ValidateBy({
        name: IS_PHONE_NUMBER,
        constraints: [region],
        validator: {
            validate: (value, args) => isPhoneNumber(value, args?.constraints[0]),
            defaultMessage: buildMessage((eachPrefix) => eachPrefix + '$property must be a valid phone number', validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=IsPhoneNumberWithLVS.js.map